export enum ScreenDeviceType {
    Mobile,
    Tablet,
    Desktop,
    DesktopXL,
}
